import { SearchCategory } from "./pageHelpers/Store/interface";

export const searchCategories = [
  {
    key: SearchCategory.Best,
    name: "Najtrafniejsze",
  },
  {
    key: SearchCategory.Articles,
    name: "Artykuły",
  },
  {
    key: SearchCategory.Podcasts,
    name: "Podcasty",
  },
  {
    key: SearchCategory.Episodes,
    name: "Epizody podcastów",
  },
  {
    key: SearchCategory.Authors,
    name: "Redaktorzy",
  },
];
